import React, { useEffect, useRef, useCallback, useState, useMemo } from 'react';
import { useDaily } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { webcamAtom, cameraInputAtom, micInputAtom } from '../../State';
import MicDetect from './MicDetect';
import FaceDetect from './FaceDetect';
import UserMediaError from '../UserMediaError/UserMediaError';
import GetMedia from './GetMedia';
import isElectron from '../../Global';
import { isMobile } from 'react-device-detect';

//メディア全般
export default function Media() {
  //Recoil系
  const [webcamState, setWebCamState] = useRecoilState(webcamAtom); //カメラのON/OFF状態
  const cameraInputState = useRecoilValue(cameraInputAtom);
  const micInputState = useRecoilValue(micInputAtom);

  //その他
  const [mediaState, setMediaState] = useState('');
  const mediaStream = useRef(null); //メディアストリーム（顔認識、音声共通）
  const faceRef = useRef(null); //childのfunctionを呼ぶ用
  const micRef = useRef(null); //childのfunctionを呼ぶ用
  const isFlgRef = useRef(true); //一定期間を開ける用
  const cameraCountRef = useRef(0); //接続カメラ数
  const micCountRef = useRef(0); //接続マイク数

  //初回呼び込み
  useEffect(() => {
    //デバイスの抜き差しイベント登録
    if (isMobile) return;
    // try {
    //   navigator.mediaDevices.ondevicechange = async (event) => {
    //     reloadMedia();
    //   };
    // } catch (e) {}
  }, []);

  //初回呼び込み
  useEffect(() => {
    console.log('ここだよ');
    console.log(mediaState);
  }, [mediaState]);

  useEffect(() => {
    reloadMedia();
  }, [webcamState]);

  // async function initMedia() {
  //   //エレクトロンの場合はシステム設定側に許可をもらう
  //   if (isElectron) {
  //     await askPermissionForElectron();
  //   }

  //   //メディア取得
  //   await getMedia();
  // }

  //エレクトロンのシステム側に許可を取る
  async function askPermissionForElectron() {
    const [micStatus, cameraStatus] = await window.myapi.askPermission();
    console.log('各種許可');
    console.log(micStatus);
    console.log(cameraStatus);

    return;
  }

  //メディアをリロード
  async function reloadMedia() {
    console.log('はろ');
    if (isFlgRef.current) {
      //フラグをオフに
      isFlgRef.current = false;

      //エレクトロンの場合はシステム設定側に許可をもらう
      if (isElectron) {
        await askPermissionForElectron();
      }

      //メディア取得
      await getMedia();

      //カメラの再アクティベイト
      if (cameraCountRef.current > 0) {
        faceRef.current?.activateCameraAgain();
      }
      //マイクの再アクティベイト
      if (micCountRef.current > 0) {
        micRef.current?.activateMicAgain();
      }

      //デバイスの抜き差しがあったときに、連続で呼ばれるとFaceDetectがバグるための処置
      setTimeout(() => {
        isFlgRef.current = true;
      }, 2000);
    }
  }

  //メディア取得
  async function getMedia() {
    //メディアストリームを取得
    const [stream, mediaError, camCount, micCount] = await GetMedia(
      mediaStream,
      cameraInputState,
      micInputState,
      false,
      false,
      webcamState,
    );

    //メディアエラー（許可がないかカメラもマイクも両方接続なし）

    if (mediaError) {
      setMediaState('error');
    } else {
      cameraCountRef.current = camCount;
      micCountRef.current = micCount;
      mediaStream.current = stream;

      //カメラがない場合はカメラオフ
      if (webcamState == false || cameraCountRef.current < 1) {
        //フェイシャルモードを押したが、カメラがない場合
        if (webcamState && cameraCountRef.current < 1) {
          alert('To use Facial Mode, you need to connect camera');
        }

        setWebCamState(false);
        setMediaState('micOnly');
      }

      //
      if (webcamState && cameraCountRef.current > 0) {
        setMediaState('cameraAndMic');
      }

      // if (micCount < 1 && callObject != null) {
      //   // callObject.setLocalAudio(false);
      // }

      //console.log('フェイス開始０' + camCount);
    }

    return;
  }

  //カメラの切り替え
  useEffect(() => {
    if (cameraInputState == '') return;
    reloadMedia();
  }, [cameraInputState]);

  //マイクの切り替え
  useEffect(() => {
    if (micInputState == '') return;
    reloadMedia();
  }, [micInputState]);

  return (
    <>
      {/*　エラーの場合 */}
      {mediaState == 'error' && <UserMediaError />}
      {/*　準備完了の場合 */}
      {mediaState == 'micOnly' && (
        <>
          {/*　マイクのセットアップ */}
          {micCountRef.current > 0 && <MicDetect mediaStream={mediaStream} ref={micRef} />}
        </>
      )}

      {mediaState == 'cameraAndMic' && (
        <>
          {/*　顔認識 */}
          <FaceDetect mediaStream={mediaStream} ref={faceRef} />

          {/*　マイクのセットアップ */}
          {micCountRef.current > 0 && <MicDetect mediaStream={mediaStream} ref={micRef} />}
        </>
      )}
    </>
  );
}
